import React, { Component } from 'react';
import '../../Asset/Css/util.css';
import '../../Asset/Css/style.bundle.css';
import '../../Asset/custom.css';
import axios from 'axios';
import global from '../global';
import { config } from '../../Constants';
import Spinner from '../Spinner';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { store } from 'react-notifications-component';
import { Row, Col, InputGroup, FormControl } from 'react-bootstrap';

import {
    Card,
    Alert,
    CardBody,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import * as rdd from 'react-device-detect';

export class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showCookieModal: false,
            PAN: '',
            RemitterName: '',
            RemitterLogo: 'client-logo.png',
            RemitterStyle: '80%',
            emailID: '',
            Password: '',
            formErrors: '',
            CompanyName: '',
            remitterCode: '',
            divLogin: true,
            loading: false,
            clientLogin: 0,
            isClient: 'none',
            isAdmin: 'none',
            RemitterID: '',
            URL: '',
            Website: 'https://www.nexdigm.com/'
        };
        this.initialState = this.state;
        localStorage.clear(); //for localStorage
        sessionStorage.clear(); //for sessionStorage

        this.CheckValidate();

        const { CompanyName } = this.props.match.params;

        if (CompanyName.toUpperCase() == 'NEXDIGM') {
            this.state.isClient = 'none';
            this.state.isAdmin = 'block';

        } else {
            this.state.isClient = 'block';
            this.state.isAdmin = 'none';
        }

        if ((rdd.browserName == "Chrome" && parseInt(rdd.browserVersion) >= 80) ||
            (rdd.browserName == "Mobile Safari" && parseInt(rdd.browserVersion) >= 13)
            || (rdd.browserName == "Safari" && parseInt(rdd.browserVersion) >= 10)
            || (rdd.browserName == "Edge" && parseInt(rdd.browserVersion) >= 80)
            || (rdd.browserName == "Firefox" && parseInt(rdd.browserVersion) >= 86)) {

        }
        else {
            window.location.href = `/Error/Browser-Not-Supported`
        }
     
    }

    CheckValidate() {
        const { CompanyName } = this.props.match.params;

        if (CompanyName == undefined) {
            window.location.href = config.url.Web_URL + `/Error/404`;
            return;
        }

        if (CompanyName == "Error") {
            window.location.href = config.url.Web_URL + `/Error/404`;
            return;
        }

        axios.get(global.UserManagement.GetRemitterIDAPI + CompanyName)
            .then(json => {

                if (json.data.status == false) {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
                else {

                    console.log(json.data.IsLatestVersionNew);

                    if (json.data.IsLatestVersionNew != "1") {
                        this.setState({
                            showCookieModal: true
                        });
                    }

                    axios.get(global.UserManagement.GetSessionDetailsAPI)
                        .then(response => {
                            if (response.data.Status) {
                                this.setState({
                                    remitterCode: response.data.RemitterCode,
                                    RemitterID: response.data.RemitterID,
                                    RemitterName: response.data.RemitterName,
                                    RemitterLogo: response.data.RemitterLogo,
                                    RemitterStyle: response.data.RemitterStyle,
                                    Website: response.data.Website,
                                    URL: config.url.Web_URL + '/' + response.data.RemitterCode
                                });

                            } else {
                                window.location.href = config.url.Web_URL + `/Error/404`;
                                return;
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }

            }).catch(error => {
                console.log(error);
            });
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handlePANChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value.toUpperCase() });
    }

    showNoti(title, message, type) {

        store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 10000,
                onScreen: true
            }
        });

    };

    handleLogin = (e) => {
        var url = config.url.Web_URL;

        if (this.state.isClient == 'block') {
            if (this.state.PAN == '' || this.state.PAN == undefined) {
                this.showNoti("Notification", "PAN is required.", "danger");
                return;
            }

            var regex = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

            if (!regex.test(this.state.PAN)) {
                this.showNoti("Notification", "PAN is not valid.", "danger");
                return;
            }
        }
        else {
            if (this.state.emailID == '' || this.state.emailID == undefined) {
                this.showNoti("Notification", "System Login ID is required.", "danger");
                return;
            }
        }

        if (this.state.Password == '' || this.state.Password == undefined) {
            this.showNoti("Notification", "Password is required.", "danger");
            return;
        }

        this.setState({ loading: true });

        if (this.state.isClient == 'block') {
            this.state.clientLogin = 1;
        }
        else {
            this.state.clientLogin = 0;
        }

        const objLogin = this.state;

        axios.post(global.UserManagement.LoginAPI, objLogin)
            .then(json => {

                if (json.data.status) {
                    window.$role = json.data.role;
                    this.SetStorage(json.data)

                    window.location.href = this.state.URL + `/Dashboard?UT=` + window.btoa(this.state.isAdmin == "block" ? "A" : "U");
                    this.setState({ loading: false });
                }
                else {

                    this.setState({ loading: false });
                    this.showNoti("Notification", "Invalid Email/Password Combination", "danger");
                }
            });
    }

    SetStorage(data) {
        localStorage.setItem('token', data.response);
    }

    handleVerifyUser = (e) => {
        window.location.href = this.state.URL + `/New-User`;
    }
    handleForgotPassword = (e) => {
        var url = config.url.Web_URL;
        window.location.href = this.state.URL + `/Forgot-Password`;
    }

    enterPressed(event) {
        var code = event.keyCode || event.which;
        if (code === 13) { //13 is the enter keycode
            this.handleLogin(event);
        }
    }

    modalCloseSave() {
        if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(function (names) {
                for (let name of names) caches.delete(name);
            });
        }

        axios.get(global.UserManagement.RefreshCookiesAPI)
            .then(json => {

                if (json.data.status) {
                    // delete browser cache and hard reload
                    window.location.reload(true);
                    this.setState({
                        showCookieModal: true
                    });
                }
                else {
                    window.location.reload(true);
                    this.setState({
                        showCookieModal: true
                    });
                }
            });


    }

     
    render() {
       
        if (this.state.loading) return <Spinner />;

        return (
            <div>
<div class="limiter">
<div class="container-login100" style="background-image: url('images/bg-01.jpg');">
<div class="wrap-login100 p-l-55 p-r-55 p-t-65 p-b-54">
<form class="login100-form validate-form">
<span class="login100-form-title p-b-49">
Login
</span>

<div class="text-right p-t-8 p-b-31">
<a href="#">
Forgot password?
</a>
</div>
<div class="container-login100-form-btn">
<div class="wrap-login100-form-btn">
<div class="login100-form-bgbtn"></div>
<button class="login100-form-btn">
Login
</button>
</div>
</div>
<div class="txt1 text-center p-t-54 p-b-20">
<span>
Or Sign Up Using
</span>
</div>

<div class="flex-col-c p-t-155">
 <span class="txt1 p-b-17">
Or Sign Up Using
</span>
<a href="#" class="txt2">
Sign Up
</a>
</div>
</form>
</div>
</div>
</div>

                <ReactNotification />

                {/*<Modal isOpen={this.state.showCookieModal} size="lg"*/}
                {/*    aria-labelledby="contained-modal-title-vcenter"*/}
                {/*    centered>*/}
                {/*    <ModalHeader>Disclaimer</ModalHeader>*/}
                {/*    <ModalBody>*/}
                {/*        <Row>*/}
                {/*            <Col md={12} className="session-modal-text">*/}
                {/*                As per section 194 of Income Tax Act, 1961, any company declaring and making payment of the dividend is required to deduct tax (TDS) on such dividend paid to the shareholders at the prescribed rates.*/}
                {/*                <br /><br />*/}
                {/*                However, no tax shall be deducted in the case of a resident individual shareholder if they furnish duly signed declaration in Form 15G / 15H.*/}
                {/*                <br /><br />*/}
                {/*                We have been authorized by {this.state.RemitterName} to obtain declarations in Form 15G / 15H from its shareholders.*/}
                {/*                <br /><br />*/}
                {/*                Click on Continue to submit Form 15G / 15H*/}
                {/*            </Col>*/}
                {/*        </Row>*/}
                {/*    </ModalBody>*/}
                {/*    <ModalFooter>*/}
                {/*        <a href="https://www.nexdigm.com/" className="headersClientNew" style={{*/}
                {/*            backgroundImage: `url(${process.env.PUBLIC_URL + "/Images/nexdigm-logo.png"})`*/}
                {/*        }}></a>*/}
                {/*        <button className="btn btn-primary m-l-10" type="button" onClick={e => this.modalCloseSave(e)}>Continue</button>*/}
                {/*    </ModalFooter>*/}
                {/*</Modal>*/}

                {/*<div className="m-grid m-grid--hor m-grid--root m-page">*/}
                {/*    <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-1" id="m_login">*/}
                {/*        <div className="m-grid__item m-grid__item--fluid m-login__wrapper">*/}
                {/*            <div className="m-login__container">*/}
                {/*                <div className="row m-row--no-padding m-row--col-separator-xl">*/}
                {/*                    <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12" style={{ display: this.state.isAdmin }}>*/}
                {/*                        <div className="reporting-portal">*/}
                {/*                            <img src={process.env.PUBLIC_URL + "/Images/EasyDiviend_Admin_logo.png"} />*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12" style={{ display: this.state.isClient }}>*/}
                {/*                        <div className="reporting-portal">*/}
                {/*                            <img src={process.env.PUBLIC_URL + "/Images/EasyDiviend_Client_logo.png"} />*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                    <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12">*/}
                {/*                        <div className="reporting-portal-right">*/}
                {/*                            <div className="reporting-portal-banner">*/}
                {/*                                <img src={process.env.PUBLIC_URL + "/Images/" + this.state.RemitterLogo} width={this.state.RemitterStyle} />*/}
                {/*                            </div>*/}
                {/*                            <div className="m-login__signin">*/}
                {/*                                <div className="m-login__form m-form" action="">*/}
                {/*                                    <div className="m-login__head">*/}
                {/*                                        <h3 className="m-login__title align-left">*/}
                {/*                                            Sign In*/}
                {/*                                        </h3>*/}
                {/*                                    </div>*/}
                {/*                                    <div className="form-group m-form__group" style={{ display: this.state.isAdmin }}>*/}
                {/*                                        <label for="exampleInputPassword1">*/}
                {/*                                            System Login ID*/}
                {/*                                        </label>*/}
                {/*                                        <input className="form-control m-input m-input--solid" type="text" name="emailID" onKeyPress={this.enterPressed.bind(this)} value={this.state.emailID} onChange={this.handleChange} placeholder="abc@domain.com" maxLength="100" autoComplete="new-password" />*/}
                {/*                                    </div>*/}
                {/*                                    <div className="form-group m-form__group" style={{ display: this.state.isClient }}>*/}
                {/*                                        <label for="exampleInputPassword1">*/}
                {/*                                            PAN*/}
                {/*                                        </label>*/}
                {/*                                        <input className="form-control m-input m-input--solid" type="text" name="PAN" onKeyPress={this.enterPressed.bind(this)} value={this.state.PAN} onChange={this.handlePANChange} placeholder="Format: AAAAA1234A" maxLength="10" autoComplete="new-password" />*/}
                {/*                                    </div>*/}
                {/*                                    <div className="form-group m-form__group">*/}
                {/*                                        <label for="exampleInputPassword1">*/}
                {/*                                            Password*/}
                {/*                                        </label>*/}
                {/*                                        <input className="form-control m-input m-input--solid" type="password" name="Password" icon="lock" onKeyPress={this.enterPressed.bind(this)} value={this.state.Password} onChange={this.handleChange} placeholder="Format: Min 8 Characters" maxLength="50" autoComplete="new-password" />*/}
                {/*                                    </div>*/}
                                                   
                {/*                                    <div className="row m-row--no-padding m-login__form-sub" style={{ display: this.state.isClient }}>*/}

                {/*                                        <div className="col m--align-right m-login__form-right">*/}
                {/*                                            <button onClick={this.handleForgotPassword} className="m-link m--font-brand" > Forgot Password ?</button>*/}
                {/*                                        </div>*/}
                {/*                                    </div>*/}
                {/*                                    <div className="m-login__form-action" >*/}
                {/*                                        <button disabled={!this.state.isVerified} onClick={this.handleLogin} className="btn btn-focus m-btn m-btn--pill m-btn--custom m-login__btn m-login__btn--primary">*/}
                {/*                                            Sign In*/}
                {/*                                        </button>*/}
                {/*                                    </div>*/}
                {/*                                    <ReCAPTCHA*/}
                {/*                                        sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"*/}
                {/*                                        //sitekey="6LczUb8bAAAAAORraH3xXWlcW4tj9wmdVGqaN46-"                                                */}
                {/*                                        onChange={this.onCAPTCHAChange}*/}
                {/*                                    />*/}
                {/*                                </div>*/}
                {/*                                <div class="m-login__account" style={{ display: this.state.isClient }}>*/}
                {/*                                    <button onClick={this.handleVerifyUser} className="m-link m-link--light m-login__account-link" > NEW USER? SIGN UP </button> <a href={process.env.PUBLIC_URL + "/Templates/Easy-Dividend-User-Manual.pdf"} download="Easy-Dividend-User-Manual.pdf"><i className="fa fa-info-circle m-l-10 m-r-10"></i></a>*/}
                {/*                                </div>*/}
                {/*                            </div>*/}
                {/*                            <div className="reporting-portal-banner p-t-0 p-b-20">*/}
                {/*                                <span>Powered by </span><img src={process.env.PUBLIC_URL + "/Images/nexdigm-logo-sm.png"} className="powered-footer" />*/}
                {/*                                <br /><span className="f-m-m"> For any issues / queries contact us at <a href="mailto:dividend.support@nexdigm.com">dividend.support@nexdigm.com</a></span>*/}

                {/*                            </div>*/}
                {/*                        </div>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}

                {/*</div>*/}
            </div>
        );
    }
}
